import { StickerApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function useRevoke() {
  const queryClient = useQueryClient();

  return useAuthMutation(StickerApi.revoke, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
    },
  });
}

export default useRevoke;
